/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { findKey } from "lodash";

import {
  CompliancePayeeType,
  CompliancePayeeTypePayload,
  ComplianceTaxpayerType,
  ComplianceTaxpayerTypePayload,
} from "~/features/myAccount/constants";
import { ComplianceDetails, ComplianceDetailsFromApi, ComplianceReviewStatus } from "~/features/myAccount/types";

const transformToComplianceDetails = (fields: Partial<ComplianceDetailsFromApi>): ComplianceDetails => {
  // Enums needs explicit comparison
  const parsedPayeeType = findKey(
    CompliancePayeeTypePayload,
    (value) => value === fields.payeeType,
  ) as CompliancePayeeType;

  const parsedTaxpayerType = findKey(
    ComplianceTaxpayerTypePayload,
    (value) => value === fields.taxpayerType,
  ) as ComplianceTaxpayerType;

  return {
    payeeType: parsedPayeeType ?? null,
    taxpayerType: parsedTaxpayerType ?? null,
    reviewStatus: fields.reviewStatus ?? ComplianceReviewStatus.PENDING,
    address1: fields.address1 ?? "",
    address2: fields.address2 ?? "",
    payeeName: fields.payeeName ?? "",
    firstName: fields.firstName ?? "",
    lastName: fields.lastName ?? "",
    city: fields.city ?? "",
    country: fields.country ?? "",
    state: fields.state ?? null,
    taxId: fields.taxId ?? "",
    zip: fields.zip ?? "",
    dateOfBirth: fields.dateOfBirth ?? "",
  };
};

export default transformToComplianceDetails;
